import ClassificationViewState from '../store/schema/ClassificationViewState';
import setMessageClassification from '../actions/setMessageClassification';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { MESSAGE_CLASSIFICATION_INFOBAR_MESSAGE_ID } from './constants';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function clearClassification(
    viewState: ClassificationViewState,
    infobarViewState: InfoBarHostViewState,
    composeId: string
) {
    if (!viewState) {
        return;
    }
    setMessageClassification(viewState, null);
    removeInfoBarMessage(infobarViewState, MESSAGE_CLASSIFICATION_INFOBAR_MESSAGE_ID, composeId);
}
